import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const HomePage = lazy(() => import('@cobliteam/home'));

const routes = [
  {
    path: Location.HOME,
    component: HomePage,
  },
];

export default routes;
